import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatorService } from '../core/translator/translator.service';
import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';


import { menu } from './menu';
import { routes } from './routes';
import { ServicesModule } from '../services/services.module';
import { SuccessPopupComponent } from './success-popup/success-popup.component';
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { LoginComponent } from './user/login/login.component';
//import { AddsettlementvendorsComponent } from './settlementvendors/addsettlementvendors/addsettlementvendors.component';
//import { ViewsettlementvendorsComponent } from './settlementvendors/viewsettlementvendors/viewsettlementvendors.component';
// import { WaitingLoaderComponent } from './waiting-loader/waiting-loader.component';
import { VirtualTerminalAccessComponent } from './user/virtual-terminal-access/virtual-terminal-access.component';
import { BnNgIdleService } from 'bn-ng-idle';

@NgModule({
    imports: [
        SharedModule,
        // RouterModule.forRoot(routes),       
        // Uat Testing Perpous
        RouterModule.forRoot(routes,{ useHash: true }), 
        ServicesModule
    ],
    declarations: [  
        SuccessPopupComponent,
        ConfirmPopupComponent,
       LoginComponent,
       //AddsettlementvendorsComponent,
       //ViewsettlementvendorsComponent,
        // WaitingLoaderComponent
        VirtualTerminalAccessComponent,
        ],
        providers:[BnNgIdleService],
    exports: [
        RouterModule
    ]
})

export class RoutesModule {
    constructor(public menuService: MenuService, tr: TranslatorService) {
        menuService.addMenu(menu);
    }
}
